import dayjs from "dayjs";

// Periods for the performance-stats KPIs (Trading page, Dashboard). start()
// is the stats' startDate; open positions are always the current ones.
export const PERFORMANCE_PERIODS = [
  { value: "all", label: "All time" },
  { value: "ytd", label: "Year to date", start: () => dayjs().startOf("year") },
  {
    value: "mtd",
    label: "Month to date",
    start: () => dayjs().startOf("month"),
  },
  { value: "30d", label: "Last 30 days", start: () => dayjs().add(-30, "day") },
];

export const findPerformancePeriod = (value) =>
  PERFORMANCE_PERIODS.find((period) => period.value === value) ||
  PERFORMANCE_PERIODS[0];

// the stats' startDate param ("YYYY-MM-DD"), none for all time
export const periodStartDate = (period) =>
  period.start?.().format("YYYY-MM-DD");
